/**
 * feedback
 * The feedback element is a small block that you can add to take
 * in feedback from a visitor whether a piece of content is helpful or not.
 */

function feedback(el, app) {
    let feedbackId;

    const $el = $(el);
    const $message = $el.find('.Ge-Feedback-Question');
    const host = $el.data('js-feedback-host');
    const forId = $el.data('js-feedback-id');
    const $yes = $el.find('[data-js-feedback-yes]');
    const $no = $el.find('[data-js-feedback-no]');
    const $send = $el.find('[data-js-feedback-send]');
    const $suggestions = $el.find('.Ge-Feedback-Suggestions');
    const $text = $el.find('textarea');


    const sendFeedback = data => {
        $message.text('Skickar...');
        const url = `${document.location.protocol}//${host}/GeneralApi`
        return $
            .ajax(url, { method: 'GET', data })
            .then(feedbackSent)
            .fail(feedbackFailed);
    }

    const sendInitialFeedback = function (wasSatisfied) {

        $yes.remove();
        $no.remove();

        let data = {
            command: 'Feedback',
            satisfied: wasSatisfied ? '1' : '0',
            forId: forId
        };
        sendFeedback( data );
    };

    const sendSuggestionFeedback = function () {

        $suggestions.remove();

        let text = $text.val();
        let data = {
            command: 'Feedback',
            satisfied: '0',
            forId: forId,
            feedbackId: feedbackId,
            message: text
        };

        sendFeedback( data );
    };

    const feedbackSent = function (data) {
        if (data.status !== 'Ok') {
            return feedbackFailed(data);
        }

        if (data.result && data.result.id) {
            feedbackId = data.result.id;
        }

        $message.text('Tack för din återkoppling!');
    };

    const feedbackFailed = function (err) {
        console.error(err);
        [$yes, $no, $text].forEach(($input) => $input.prop('disabled', false));

        // ga
        app.trigger('beacon', 'faq-feedback-submission-failed');
    };

    const textChanged = function () {
        $send
            .prop('disabled', false)
            .removeClass('Ge-Btn--shy')
            .addClass('Ge-Btn--primary')
            .text('Skicka');
    };

    // attach event listeners
    $yes.on('click', e => {
        e.preventDefault();

        // reveal the extra form to accessibility
        $suggestions.remove();
        sendInitialFeedback(true);

        // ga
        app.trigger('beacon', 'faq-feedback-yes');
    });

    $no.on('click', e => {
        e.preventDefault();
        // reveal the extra form to accessibility
        $suggestions.find('[name="feedback"]').attr('tabindex', '0').attr('aria-hidden', 'false');
        $suggestions.find('[data-js-feedback-send]').attr('tabindex', '0').attr('aria-hidden', 'false');
        $suggestions.toggleClass('Ge-Feedback-Suggestions--Active', true);
        sendInitialFeedback(false);

        // ga
        app.trigger('beacon', 'faq-feedback-no');
    });

    $send.on('click', e => {
        e.preventDefault();
        sendSuggestionFeedback();
    });

    $text.on('keyup', textChanged);
}

feedback.selector = '[data-js-feedback]';
export default feedback;
